<div class="content p-4">

    <div class="text-md font-semibold text-primary mb-4">{{publicationAccessService.pubUuid}}</div>
    <button mat-stroked-button (click)="checkAgain()">
        <mat-icon [svgIcon]="'heroicons_solid:refresh'"></mat-icon>
        <span class="ml-1">{{'Force evaluation'|transloco}}</span>
    </button>
    <a [href]="editPublicationLink" class="mat-stroked-button ml-2" target="_blank">
        <mat-icon [svgIcon]="'heroicons_solid:external-link'"></mat-icon>
        <span class="ml-1">{{'Edit publication'|transloco}}</span>
    </a>

    <div class="flex flex-col h-full pt-2 anotherBody">

        <mat-tab-group #tabGroup [dynamicHeight]="false" class="h-full">

            <mat-tab label="{{'Rules'|transloco}}" bodyClass="h-full pt-2">
                <ng-template matTabContent>

                    <ng-container *ngIf="(publicationAccessService.allGroups$|async) as pubGroup">

                        <div class="mt-4 text-md font-semibold text-primary">{{'Publications élues / sélectionnées :'|transloco}}</div>

                        <ng-container *ngIf="(evalResultDebug?.sqlFake?.result) as result">
                            <div *ngFor="let agroup of result">

                                <div>{{agroup.pubUuid}} / {{agroup.groupId}}</div>
                                <div>
                                    {{pubGroup.data[agroup.groupId]|json}}
                                </div>

                            </div>
                        </ng-container>

                        <div class="mt-4 text-md font-semibold text-primary">Table What</div>

                        <pre>{{electedGroupIndex|json}}</pre>

                        <ng-container *ngIf="evalResultDebug?.sql3">
                            <div class="mb-2 lock p-6 w-full bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
                                 *ngFor="let aGroup of evalResultDebug.sql3.result"
                                 [ngClass]="{'rule-match border-4': electedGroupIndex.includes(aGroup.groupId)}"
                            >

                                <div class="text-xl mb-1">{{aGroup.groupTitle}} ({{aGroup.groupId}})
                                    / {{aGroup.comId}}</div>

                                <textarea fuse-highlight lang="sql">{{aGroup.sqlRule}}</textarea>
                                <div class="text-md m-2">ExtValues {{aGroup.fields|json}} :</div>
                                <textarea fuse-highlight
                                          lang="json">{{extValuesPerGroup[aGroup.groupId]|json}}</textarea>

                            </div>
                        </ng-container>

                    </ng-container>

                </ng-template>
            </mat-tab>

            <mat-tab label="{{'Surveys'|transloco}}" bodyClass="h-full pt-2">
                <ng-template matTabContent>
                    <div class="p-4 flex flex-roww">
                        <a *ngFor="let id of surveyIds" [href]="clientAppUrl + '/survey/builder/' + id" class="mat-stroked-button" target="_blank">
                            {{'Edit survey'|transloco}} <span class="font-bold ml-2">{{id}}</span><b></b>
                        </a>
                    </div>
                </ng-template>
            </mat-tab>

            <mat-tab label="Messages" bodyClass="h-full pt-2">
                <ng-template matTabContent>
                    <ng-container *ngIf="(publicationMessagesService.messages$|async) as messages">
                        <div *ngFor="let aMindex of messages.index">
                            <pre>{{messages.data[aMindex]|json}}</pre>
                        </div>
                    </ng-container>
                </ng-template>
            </mat-tab>

            <mat-tab label="Info" bodyClass="h-full pt-2">
                <ng-template matTabContent>

                    <div *ngIf="debugInfos.publication?.redirectInfos"
                         class="mt-4 mb-4 text-md font-semibold text-primary">
                        <span>{{'Redirect Infos'|transloco}}</span>
                        <span class="ml-1 px-4 py-2 rounded-full text-white bg-warn-300 font-semibold text-sm align-center"
                              *ngIf="!debugInfos.publication?.redirectInfos?.hasRedirectionLinks">Liens non activés ?</span>
                    </div>
                    <div>
                        <a [href]="debugInfos.publication?.redirectInfos.complete" target="_blank">Complete
                            : {{debugInfos.publication?.redirectInfos.complete}}</a>
                    </div>
                    <div>
                        <a [href]="debugInfos.publication?.redirectInfos.screenout" target="_blank">Screenout
                            : {{debugInfos.publication?.redirectInfos.screenout}}</a>
                    </div>

                    <div class="mt-4 text-md font-semibold text-primary">allwaysDisplayHomePageContributor</div>
                    <pre>{{publicationAccessService.publication$|async|json}}</pre>

                </ng-template>
            </mat-tab>

            <mat-tab label="Debug" bodyClass="h-full pt-2">
                <ng-template matTabContent>
                    <pre>{{debugInfos|json}}</pre>
                </ng-template>
            </mat-tab>

        </mat-tab-group>

    </div>

</div>
